import { createStyles, makeStyles, Theme } from "@material-ui/core";
import StvPage from "../app/ctx-provider/StvPage";
import useAppCtx from "../app/ctx-provider/useAppCtx";
import useAppContent from "../app/useAppContentHook";


const useStyles = makeStyles((theme: Theme) => createStyles({

    root: {
        marginBottom: 20,
        //height: '100%'
    },
    main: {
        maxWidth: 670,
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    mainBlur: {
        /*
        - webkit - filter: blur(20px);
        - moz - filter: blur(20px);
       -o - filter: blur(20px);
         -ms - filter: blur(20px);
         */
        filter: 'blur(20px)'
    },
}));

const AppMain: React.FC = () => {
    const { appCtxBo } = useAppCtx();
    const { content } = useAppContent();
    const classes = useStyles();

    const disableContent:boolean = appCtxBo.renderMainKontakt === true;
    const isFaceliftHomepage:boolean = (appCtxBo.currentPage === StvPage.HOMEPAGE_FACELIFT || appCtxBo.currentPage === StvPage.HOMEPAGE_DOGORAMA);

    return (
        <div className={`${classes.root} ${disableContent && classes.mainBlur} ${isFaceliftHomepage ? '' : classes.main}`}>
            {content}
        </div >);
}

export default AppMain;